module.exports = "/static/assets/e5c63221bbefc5554a1ecbbba8a0f342.png";